
<script setup>
import { ref, computed } from 'vue';
import RedesignTag from "@/components/RedesignBaseComponents/RedesignTag.vue";
import BaseButton from "@/components/Common/Buttons/BaseButton.vue";
import RedesignToggleButton from "@/components/RedesignBaseComponents/RedesignToggleButton.vue";
import RedesignBaseCard from "@/components/RedesignBaseComponents/RedesignBaseCard.vue";
import RedesignBaseIcon from "@/components/RedesignBaseComponents/RedesignBaseIcon.vue";
import RedesignExtensionCard from "@/components/RedesignComponents/Cards/RedesignExtensionCard.vue";
import RedesignExtensionCardHeader from "@/components/RedesignComponents/Cards/ExtensionCard/RedesignExtensionCardHeader.vue";
import RedesignExtensionCardBody from "@/components/RedesignComponents/Cards/ExtensionCard/RedesignExtensionCardBody.vue";
import RedesignExtensionCards from "@/components/RedesignComponents/Cards/ExtensionCard/RedesignExtensionCards.vue";

// Props
const props = defineProps({
    cols: {
        type: Number,
        default: 3
    },
    cards: {
        type: Array,
        default: () => []
    }
});

// Reactive State
const isToggled = ref(false);
const buttonSizes = ['sm', 'xs', 'sml', 'md'];
const tags = ref([
    {
        color: '#E39B08',
        fontSize: '11px',
        showInCard: false,
        backgroundColor: '#FFF8EA',
        borderColor: '',
        tagContent: [{ iconName: 'ZoomIn', text: '12:13' }]
    },
    {
        color: '#FF4D4D',
        fontSize: '11px',
        borderColor: '',
        showInCard: true,
        backgroundColor: '#FFF1F1',
        tagContent: [{ iconName: 'Heart', text: '12:43' }]
    },
    {
        color: 'green',
        fontSize: '11px',
        backgroundColor: 'transparent',
        showInCard: false,
        borderColor: 'green',
        tagContent: [{ iconName: 'Star', text: '90%' }]
    },
    {
        color: '',
        fontSize: '11px',
        backgroundColor: '#F2F2F2',
        showInCard: true,
        borderColor: '',
        tagContent: [
            { iconName: 'ZoomIn', text: '12:13' },
            { iconName: 'Heart', text: '10:43' }
        ]
    },
    {
        color: '',
        fontSize: '11px',
        backgroundColor: '#F2F2F2',
        showInCard: true,
        borderColor: '',
        tagContent: [{ text: '12:13' }]
    }
]);

const buttonTypes = [
    { type: 'primary', label: 'Rounded', round: true },
    { type: 'danger', label: 'Danger' },
    { type: 'primary', label: 'Primary outline', outline: true },
    { type: 'default', label: 'Default outline', outline: true },
    { type: 'default', label: 'Default' },
    { type: 'default', label: 'Disabled', disabled: true }
];

// Computed
const renderedButtons = computed(() =>
    buttonTypes.map(type => ({
        ...type,
        buttons: buttonSizes.map(size => ({
            size,
            type: type.type,
            round: type.round,
            outline: type.outline,
            disabled: type.disabled
        }))
    }))
);

// Methods
const handleToggle = () => {
    isToggled.value = !isToggled.value;
};
</script>

<template>
    <div class="p-10">
        <h1 class="font-bold widget-header-title mb-14">Style Guide</h1>
        <div class="text-primary-600 text-2xl mb-6">Tags</div>
        <div class="flex mb-10 components-wrap">
            <RedesignTag
                v-for="(tag, index) in tags"
                :tag-content="tag"
                :key="index"
                class="mb-4 mr-4">
            </RedesignTag>
        </div>
        <div class="text-primary-600 text-3xl mb-2">
            Buttons:
        </div>
        <div class="components-wrap">
            <div class="gap-8">
                <div
                    v-for="(type, index) in renderedButtons"
                    :key="index"
                    class="flex items-end gap-4 mb-2"
                >
                    <div class="text-primary-600 text-2xl mr-8">
                        {{ type.label }}:
                    </div>
                    <BaseButton
                        v-for="(button, buttonIndex) in type.buttons"
                        :key="`${type.label}-${buttonIndex}`"
                        :round="button.round"
                        :size="button.size"
                        tag="button"
                        :type="button.type"
                        class="uppercase mb-2"
                        :outline="button.outline"
                        :disabled="button.disabled"
                    >
                        {{`button ${button.size}`}}
                    </BaseButton>
                </div>
            </div>
        </div>
        <div class="text-primary-600 text-3xl mb-2">
            Toggle Buttons:
        </div>
        <RedesignToggleButton
            @toggle="handleToggle"
            bgColor="blue"
            borderRadius="18px"
            class="mb-8"
            size="xs"
            :on-label="'show All'"
            :off-label="'show All'"
            type="primary"
            :round="true"
            :disabled="false"
        >
        </RedesignToggleButton>
    </div>
</template>

<style scoped lang="scss">
.components-wrap {
    @apply p-12 border-2 w-max shadow-2xl;
}
</style>


